import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Animation, TimelineLite, TweenLite, TweenMax} from "gsap";
import {CreepyCarnivalTwoGameConfig} from "../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "../CreepyCarnivalTwoSoundConfig";
import {CreepyCarnivalTwoGameMode} from "../gamemode/CreepyCarnivalTwoGameMode";
import {CCTwoFreeSpinEntryEvents} from "../screen/freespinintro/CreepyCarnivalTwoFreespinIntroController";
import {CreepyCarnivalTwoParsedInitData} from "../server/data/CreepyCarnivalTwoParsedInitData";
import {CCTwoStarSpinIntroEvents} from "../starspin/controller/StarSpinIntroController";
import {CreepyCarnivalBulbsEvent} from "../utils/CCTwoBulb";
import {CCTwoInitialWPEvents} from "../winpresentation/initial/CreepyCarnivalTwoInitialWPController";
import {CCTwoMultiplierEvents} from "./CCTwoMultiplierEvents";

export class CCTwoMultiplierIndicator extends BaseView {

    private _currentMultiplier:number;
    private _nextModeMultiplier:number;
    private _layer:PIXI.Container;
    private _container_x1:PIXI.Container = new PIXI.Container();
    private _container_x2:PIXI.Container = new PIXI.Container();
    private _container_x3:PIXI.Container = new PIXI.Container();
    private _allContainers:PIXI.Container[] = [];
    private _baseContainerList:PIXI.Container[] = [];
    private _baseContainer:PIXI.Container = new PIXI.Container();
    private _freeSpinContainer:PIXI.Container = new PIXI.Container();
    private _fs_container_x5:PIXI.Container = new PIXI.Container();
    private _freeSpinContainerList:PIXI.Container[] = [];
    private _base_multipliers:object[];
    private _freespin_multipliers:object[];
    private _gameMode:string = 'NORMAL';
    private _nextMode:string = 'NORMAL';
    private _usableMultipliers:object[];
    private _nextSwitchableState:string = 'NORMAL';
    private _mainGamePulsator:PIXI.Container = new PIXI.Container();
    private _freespinPulsator:PIXI.Container = new PIXI.Container();
    private _currentPulsator:PIXI.Container;
    private _pulseTween:TweenLite;
    private _background:PIXI.Sprite;
    private _FSbackground:PIXI.Sprite;
    private _respinsPlayedCount:number = -1;
    private _currentGameMode:string;
    private currentWinRatio:number;
    private _multiplierBlinkingAnim:Animation;
    private gameStarted:boolean = false;
    private orientation:string = "";
    private _pulseAddedForMultiplier = 0;

    constructor() {
        super();

        this._currentMultiplier = 1;
        this._nextModeMultiplier = 1;
        this._layer = StageManager.getLayer(CreepyCarnivalTwoGameConfig.instance.LAYERS.MULTIPLIER.name);
    }

    public setState(playSmoke?:boolean):void {
        let state = this._gameMode = this._nextSwitchableState;
        if((this._currentGameMode === "RESPIN_FREESPIN" || this._currentGameMode === "FREESPIN") && (this._nextMode === "NORMAL" || this._nextMode === "STAR_SPIN")) {
            this.killFreeGameBulbs();
        }
        if(state == 'NORMAL' || state === "STAR_SPIN") {
            this._baseContainer.visible = true;
            this._freeSpinContainer.visible = false;
            this._allContainers = this._baseContainerList;

            this._usableMultipliers = this._base_multipliers;
            this._currentPulsator = this._mainGamePulsator;
        } else {
            this._baseContainer.visible = false;
            this._freeSpinContainer.visible = true;
            this._allContainers = this._freeSpinContainerList;
            this._usableMultipliers = this._freespin_multipliers;
            this._currentPulsator = this._freespinPulsator;
        }
        if(this._nextMode !== "STAR_SPIN" && this._gameMode.indexOf('FREESPIN') == -1) { //mainGame
            if(this._nextMode.indexOf("RESPIN") !== -1) { //nextisRespin
                this.updateMultiplierState(this._nextModeMultiplier + 1, 'cirkle');
            } else if((this._currentGameMode === "FREESPIN" || this._currentGameMode === "RESPIN_FREESPIN") && this._nextMode === "NORMAL") {//if first normal spin , as response is not recieved yet setting default value
                this.updateAllMultipliers();
            } else {
                this.updateMultiplierState(1, 'cirkle');
            }
        } else if(this._gameMode.indexOf('FREESPIN') !== -1) {
            this.updateMultiplierState(this._nextModeMultiplier, 'normal');//FreeGame
            if((this._currentGameMode == "NORMAL" || this._currentGameMode == "RESPIN_MAIN" || this._currentGameMode === "STAR_SPIN") && this._nextMode.indexOf('FREESPIN') !== -1) {
                playSmoke && this.playSmokeAnimation(true);
            }
        } else if(this._nextMode === "STAR_SPIN") {
            this.updateMultiplierState(1, 'cirkle');
        }
        if(this._gameMode === "STAR_SPIN") {
            this.hideIndicatorsExcept([1]);
        }
    }

    public playSmokeAnimation(playIndicators:boolean) {
        let multiplierSmoke = new TimelineSprite(GameResources.getTextures("cloud"));
        multiplierSmoke.name = "multiplierSmoke";
        this._freeSpinContainer.addChild(multiplierSmoke);
        multiplierSmoke.position.set(152, 0);
        SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.X5_SMOKE);
        multiplierSmoke.getAnimation([0], function() {
        }, () => {
            if(playIndicators) {
                this.showFreeSpinsMultIndicators();
            }
            this._freeSpinContainer.removeChild(multiplierSmoke);
            multiplierSmoke.destroy();
            if(this._currentGameMode.indexOf("FREESPIN") !== -1 && this._nextSwitchableState == "NORMAL") {
                EventHandler.dispatchEvent(new GameEvent(CCTwoFreeSpinEntryEvents.RESET_MULTIPLIER));
            }
        });
    }

    protected initAnimations():void {
        this._base_multipliers = [
            {
                name : "x1",
                indicator : 'x1_glow',
                glowScale : 0.60,
                x : 300,
                y : 77,
                id : 1,
                img : null,
                scale : 0.6,
                rotation : 0,
                pulseEffect : true,
                rippleCount : 0
            },
            {
                name : "x2",
                indicator : 'x2_glow',
                glowScale : 0.57,
                x : 365,
                y : 60,
                id : 2,
                img : null,
                scale : 0.57,
                rotation : 0,
                pulseEffect : true,
                rippleCount : 0
            },
            {
                name : "x3",
                indicator : 'x3_glow',
                glowScale : 0.60,
                x : 445,
                y : 65,
                id : 3,
                img : null,
                scale : 0.60,
                rotation : 0,
                pulseEffect : true,
                rippleCount : 0
            }
        ];
        this._freespin_multipliers = [

            {
                name : "x5",
                indicator : 'x5bulb',
                x : 367,
                y : 55,
                id : 5,
                glow1 : {glowX : 345, glowY : 92},
                glow2 : {glowX : 371, glowY : 90},
                glow3 : {glowX : 399, glowY : 92},
                img : null,
                alpha : 1,
                scale : 1,
                rotation : 0
            }
        ];
        this._usableMultipliers = this._base_multipliers;
        this._currentPulsator = this._mainGamePulsator;
        this.createBaseContainer();
        this.createFreespinContainer();
        this.setState();
    }

    protected onResize(resizeData:IResizeData):void {

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._freeSpinContainer && this._freeSpinContainer.position.set(-113, -53);
            this._baseContainer && this._baseContainer.position.set(-115, -53);
            this._freeSpinContainer && this._freeSpinContainer.scale.set(1.5);
            this._baseContainer && this._baseContainer.scale.set(1.5);
            this.orientation = Orientation.PORTRAIT;
            if(this.orientation === Orientation.PORTRAIT && this._gameMode.indexOf("FREESPIN") !== -1) {
                this._currentPulsator.scale.set(1.5);
                this._currentPulsator.position.set(-112, -50);
            } else {
                this._currentPulsator.scale.set(1);
                this._currentPulsator.position.set(0, 0);
            }
        } else {
            this._baseContainer && this._baseContainer.getChildAt(0).scale.set(1);
            this._background.position.set(CreepyCarnivalTwoGameConfig.instance.REEL_AREA_POS_X + 57, 18);
            this.orientation = "";
            this._freeSpinContainer && this._freeSpinContainer.position.set(0, 0);
            this._freeSpinContainer && this._freeSpinContainer.scale.set(1);
            this._baseContainer && this._baseContainer.scale.set(1);
            this._baseContainer && this._baseContainer.position.set(0, 0);
            this._currentPulsator.scale.set(1);
            this._currentPulsator.position.set(0, 0);
        }
    }

    protected onBeforeSpinStart():void {
        this._currentGameMode = this._gameMode;
        this.setState();

        if((this._gameMode.indexOf(CreepyCarnivalTwoGameMode.FREESPIN) === -1)) {
            return;
        }
        if((this._gameMode.indexOf('FREESPIN') !== -1) && (this._nextMode.indexOf("RESPIN") === -1)) {
            this.hideAllIndicators();
        }

        if(this._nextMode.indexOf('RESPIN') === -1) {
            this._respinsPlayedCount = 0;
        } else {
            this._respinsPlayedCount += 1;
        }
        setTimeout(this.litMultiplierLamps.bind(this, this._respinsPlayedCount), 300);
    }

    protected onSpinStart():void {
    }

    protected onSpinAlreadyStarted():void {
        this!._currentPulsator && this.hideIndicatorsExcept([], true);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, CCTwoStarSpinIntroEvents.ENTER_IN_STAR_SPIN, (event:GameEvent) => this.enterInStarSpin());
        EventHandler.addEventListener(this, CCTwoStarSpinIntroEvents.EXIT_FROM_STAR_SPIN, (event:GameEvent) => this.exitFromStarSpin());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event:GameEvent) => this.onReelsStopped());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, SpinEvent.STARTED, (event:GameEvent) => this.onSpinAlreadyStarted());
        EventHandler.addEventListener(this, SpinEvent.START, (event:GameEvent) => this.onSpinStart());
        EventHandler.addEventListener(this, SpinEvent.IDLE, (event:GameEvent) => this.onIdle());
        EventHandler.addEventListener(this, CCTwoFreeSpinEntryEvents.RESET_MULTIPLIER, (event:GameEvent) => this.setState(event.params[0]));
        EventHandler.addEventListener(this, CCTwoFreeSpinEntryEvents.PLAY_SMOKE_ANIMATION, (event:GameEvent) => this.playSmokeAnimation(event.params[0]));
        EventHandler.addEventListener(this, CCTwoInitialWPEvents.DISPLAY_STAR_SPIN_BULBS_AT_ONCE, (event:GameEvent) => this.hideMultipliers());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.SHOW_STAR_SPIN_BULBS, (event:GameEvent) => this.hideMultipliers());
        EventHandler.addEventListener(this, CreepyCarnivalBulbsEvent.HIDE_STAR_SPIN_BULBS, (event:GameEvent) => this.showMultipliers());
        EventHandler.addEventListener(this, CCTwoMultiplierEvents.APPLY_MULTIPLIER, (event:GameEvent) => this.tryAddPulse());
    }

    protected hideMultipliers():void {
        this.hideAllIndicators();
        TweenLite.to(this._container_x2, 0.3, {
            alpha : 0
        });
        TweenLite.to(this._container_x3, 0.3, {
            alpha : 0
        });
    }

    protected showMultipliers():void {
        TweenLite.to(this._container_x2, 0.3, {
            alpha : 1
        });
        TweenLite.to(this._container_x3, 0.3, {
            alpha : 1
        });
    }

    protected onIdle():void {
        this.gameStarted = true;
        this.updateAllMultipliers();
        if(this._gameMode.indexOf('FREESPIN') !== -1) {
            this.hideIndicatorsExcept();
        }
    }

    private killFreeGameBulbs():void {
        this._usableMultipliers.forEach(function(item, index) {
            (item as any).indicator[2].alpha = 0;
            (item as any).indicator[1].alpha = 0;
            (item as any).indicator[0].alpha = 0;
        }, this);
    }

    private litMultiplierLamps(respinPlayedCount:number):void {
        this._usableMultipliers.forEach(function(item, index) {
            if(respinPlayedCount > 1) {
                (item as any).indicator[2].alpha = 1;
                (item as any).indicator[1].alpha = 1;
                (item as any).indicator[0].alpha = 1;
            } else if(respinPlayedCount > 0) {
                (item as any).indicator[2].alpha = 0;
                (item as any).indicator[1].alpha = 1;
                (item as any).indicator[0].alpha = 1;
            } else if(respinPlayedCount === 0) {
                (item as any).indicator[2].alpha = 0;
                (item as any).indicator[1].alpha = 0;
                (item as any).indicator[0].alpha = 1;
            }
        }, this);
    }

    private enterInStarSpin():void {
        this.hideIndicatorsExcept([1]);
    }

    private tryAddPulse() {
        this.updateMultiplierState(this._currentMultiplier, 'lit');

        this.addPulse(this._currentMultiplier);
    }

    private exitFromStarSpin():void {
        this._respinsPlayedCount = 0;
        this.hideIndicatorsExcept();
        this.updateAllMultipliers();
    }

    private onReelsStopped() {
        this.hideIndicatorsExcept();
    }

    private disableAllMultipliers():void {
        if(this._gameMode.indexOf('FREESPIN') == -1) {
            this.updateAllMultipliers('dim');
            this.hideAllIndicators();
        } else {
            if(this._multiplierBlinkingAnim) {
                this._multiplierBlinkingAnim.kill();
            }
            this.updateAllMultipliers('normal');
        }
    }

    private createBaseContainer():void {
        this._baseContainerList.push(this._container_x1);
        this._baseContainerList.push(this._container_x2);
        this._baseContainerList.push(this._container_x3);
        this._background = new PIXI.Sprite(GameResources.getTextures("assets/multiplier")[0]);
        this._FSbackground = new PIXI.Sprite(GameResources.getTextures("assets/x5_frame")[0]);
        this._background.position.set(CreepyCarnivalTwoGameConfig.instance.REEL_AREA_POS_X + 57, 18);
        this._FSbackground.position.set(CreepyCarnivalTwoGameConfig.instance.REEL_AREA_POS_X + 47, 14);
        this._baseContainer.addChild(this._background);
        this._baseContainer.addChild(this._mainGamePulsator);
        this._baseContainer.addChild(this._container_x1);
        this._baseContainer.addChild(this._container_x2);
        this._baseContainer.addChild(this._container_x3);
        this._layer.addChild(this._baseContainer);
    }

    private updateMultiplierState(index:number, stateToLaunch:string):void {

        this.disableAllMultipliers();
        let multiplierObject:any = null;
        for(let i = 0; i < this._usableMultipliers.length; i++) {
            let currentNode:any = (this._usableMultipliers[i]);
            if(currentNode.id == index) {
                multiplierObject = (this._usableMultipliers[i] as any);
                break;
            }
        }
        if(stateToLaunch !== 'lit' || this._gameMode === CreepyCarnivalTwoGameMode.NORMAL || this._gameMode === CreepyCarnivalTwoGameMode.RESPIN || this._gameMode === CreepyCarnivalTwoGameMode.STAR_SPIN) {
            let textureName:string = "assets/" + multiplierObject.name + "_" + stateToLaunch;

            let img:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(textureName)[0]);

            let parentContainer:any = multiplierObject.img.parent;
            multiplierObject.img.parent.removeChild(multiplierObject.img);
            img.scale.set(multiplierObject.scale);
            img.rotation = (multiplierObject.rotation * Math.PI) / 360;
            img.anchor.set(0.5, 0.5);

            multiplierObject.img = img;
            parentContainer.addChild(img);
            if(stateToLaunch === "cirkle") {
                switch(index) {
                    case 2:
                        SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.X2_MULTIPLIER_SOUND);
                        break;
                    case 3:
                        SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.X3_MULTIPLIER_SOUND);
                        break;
                }
            }
        } else if(stateToLaunch == 'lit') {
            if(this.currentWinRatio) {
                this.blinkingEffect();
            }
        }
    }

    private updateAllMultipliers(state:string = 'normal'):void {
        this.gameStarted = true;
        let img:PIXI.Sprite,
            textureName:string,
            container:PIXI.Container;
        let glow:PIXI.Sprite;

        if(state == 'normal') {
            this.hideIndicatorsExcept();
        }

        if(this._currentPulsator.children.length == 0) {


            this._usableMultipliers.forEach((item, index) =>  {
                glow = new PIXI.Sprite(GameResources.getTextures(("assets/" + (item as any).indicator))[0]);

                glow.visible = false;
                glow.anchor.set(0.5, 0.5);

                let glowScale = (item as any).glowScale;
                if(glowScale) {
                    glow.scale.set(glowScale);
                }
                if(this._gameMode.indexOf('FREESPIN') == -1) {
                    this._currentPulsator.addChild(glow);
                    glow.position.set((item as any).x, (item as any).y);
                    (item as any).indicator = glow;
                } else {
                    if((item as any).glow1) {
                        let glow1 = new PIXI.Sprite(GameResources.getTextures(("assets/" + (item as any).indicator))[0]);
                        let glow2 = new PIXI.Sprite(GameResources.getTextures(("assets/" + (item as any).indicator))[0]);
                        let glow3 = new PIXI.Sprite(GameResources.getTextures(("assets/" + (item as any).indicator))[0]);
                        glow1.alpha = 0;
                        glow1.anchor.set(0.5, 0.5);
                        glow2.alpha = 0;
                        glow2.anchor.set(0.5, 0.5);
                        glow3.alpha = 0;
                        glow3.anchor.set(0.5, 0.5);
                        this._currentPulsator.addChild(glow1);
                        this._currentPulsator.addChild(glow2);
                        this._currentPulsator.addChild(glow3);
                        glow1.position.set((item as any).glow1.glowX, (item as any).glow1.glowY);
                        glow2.position.set((item as any).glow2.glowX, (item as any).glow2.glowY);
                        glow3.position.set((item as any).glow3.glowX, (item as any).glow3.glowY);
                        (item as any).indicator = [glow1, glow2, glow3];
                        if(this.orientation === Orientation.PORTRAIT) {
                            this._currentPulsator.scale.set(1.5);
                            this._currentPulsator.position.set(-112, -50);

                        } else {
                            this._currentPulsator.scale.set(1);
                            this._currentPulsator.position.set(0, 0);
                        }
                    }
                }
            }, this);
        }
        this._usableMultipliers.forEach((item, index)=> {
            container = this._allContainers[index];
            container.position.set((item as any).x, (item as any).y);

            textureName = "assets/" + (item as any).name + "_" + state;
            img = new PIXI.Sprite(GameResources.getTextures(textureName)[0]);
            img.visible = true;
            img.scale.set((item as any).scale);
            img.rotation = (item as any).rotation * Math.PI / 360;
            img.anchor.set(0.5, 0.5);

            (item as any).img = img;
            if(container.children.length > 0) {
                //container.removeChildAt(0);
                container.removeChildren();
            }
            container.addChild(img);
        }, this);
    }

    private hideIndicatorsExcept(indexes:number[] = [], firstIndicatr:boolean = false) {
        if(this._currentPulsator.children.length == 0) {
            return;
        }
        this._usableMultipliers.forEach(function(item, index) {
            if(indexes.indexOf((item as any).id) == -1) {
                if((item as any).pulseEffect) {
                    (item as any).indicator.visible = false;
                } else {
                    if(firstIndicatr) {
                        (item as any).indicator[0].alpha = 1;
                    }
                }
            }
        }, this);
    }

    private hideAllIndicators(_usableMultipliers?:object[]) {
        this._usableMultipliers.forEach(function(item, index) {

            if((item as any).pulseEffect) {
                (item as any).indicator.visible = false;
            } else {
                (item as any).indicator[2].alpha = 0;
                (item as any).indicator[1].alpha = 0;
                (item as any).indicator[0].alpha = 0;
            }
        }, this);
    }

    private createFreespinContainer():void {
        this._FSbackground = new PIXI.Sprite(GameResources.getTextures("assets/x5_frame")[0]);

        this._FSbackground.position.set(CreepyCarnivalTwoGameConfig.instance.REEL_AREA_POS_X + 47, 14);
        this._freeSpinContainer.addChild(this._FSbackground);
        this._freeSpinContainerList.push(this._fs_container_x5);
        this._freeSpinContainer.addChild(this._fs_container_x5);

        this._layer.addChild(this._freeSpinContainer);
        this._layer.addChild(this._freespinPulsator);
    }

    private addPulse(index:number):boolean {
        this._pulseAddedForMultiplier = index;
        let multiplierObject:any = null;
        for(let i = 0; i < this._usableMultipliers.length; i++) {
            let currentNode:any = (this._usableMultipliers[i]);
            if(currentNode.id === index) {
                multiplierObject = (this._usableMultipliers[i] as any);
                break;
            }
        }

        let indicatorInitiated = multiplierObject.indicator.visible;
        if(multiplierObject.pulseEffect) {
            multiplierObject.indicator.scale.set(multiplierObject.glowScale * 3 / 4);
            multiplierObject.indicator.visible = true;
            let duration:number = 0.2;
            let pulseDelay:number = 0.2;

            if(!indicatorInitiated) {
                this._pulseTween = TweenLite.to(multiplierObject.indicator.scale, duration, {
                    x : multiplierObject.glowScale,
                    y : multiplierObject.glowScale
                });
            } else {
                TweenLite.to(multiplierObject.indicator.scale, duration / 3,
                    {
                        delay : pulseDelay,
                        x : multiplierObject.glowScale * 5 / 4,
                        y : multiplierObject.glowScale * 5 / 4,
                        onComplete : function() {
                            TweenLite.to(multiplierObject.indicator.scale, duration / 3,
                                {
                                    x : multiplierObject.glowScale,
                                    y : multiplierObject.glowScale,
                                }
                            )
                        }.bind(this)
                    }
                );
            }
            return !indicatorInitiated;
        }
        return false;
    }

    private onServerDataParsed(data:CreepyCarnivalTwoParsedInitData):void {
        this._gameMode = data.mode;
        this._currentGameMode = data.mode;
        this._nextMode = data.nextMode;
        this._nextSwitchableState = data.nextMode;
        this._respinsPlayedCount = data.respinsPlayedCount;
        this.currentWinRatio = data.currentWinRatio;
        if((data.mode == "NORMAL" || data.mode == CreepyCarnivalTwoGameMode.RESPIN) && data.nextMode == CreepyCarnivalTwoGameMode.FREESPIN) { //going to freespins
            this._respinsPlayedCount = 0;
        }
        if((data.nextMode.indexOf('FREESPIN') == -1) && data.nextMode.indexOf('STAR_SPIN') === -1) {
            this._nextSwitchableState = 'NORMAL';
        }
        if(data.nextMode === "NORMAL" && this._gameMode.indexOf('FREESPIN') !== -1) { //returning to maingame
            this._nextModeMultiplier = data.currentMultiplier;
        } else if((data.nextMode.indexOf('FREESPIN') !== -1)) { //going to freespins and in freespins
            this._nextModeMultiplier = 5;
        }
        this._currentMultiplier = data.multiplier;

        if(data.nextMode.indexOf('FREESPIN') == -1 && data.mode.indexOf('FREESPIN') == -1) { //in main game only
            this._nextModeMultiplier = data.multiplier;
        }

        this._pulseAddedForMultiplier = 0;
    }

    private blinkingEffect() {
        let _this = this;
        if(this._allContainers[0].children.length == 0) {
            return
        }
        this._usableMultipliers.forEach(function(item, index) {
            if((item as any).id == 5) {
                let normalMultiplier = _this._allContainers[index].getChildAt(0);
                normalMultiplier.name = "normalMultiplier";
                let textureName:string = "assets/x5_lit";
                let litMutilplier:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(textureName)[0]);
                litMutilplier.name = "litMultiplier";
                _this._allContainers[index].addChild(litMutilplier);
                litMutilplier.alpha = 0;
                litMutilplier.anchor.set(0.5, 0.5);
                litMutilplier.position.set(normalMultiplier.x, normalMultiplier.y);
                _this._multiplierBlinkingAnim = TweenMax.fromTo(litMutilplier, 0.1, {
                    alpha : 0
                }, {
                    alpha : 1,
                    yoyo : true,
                    repeat : 4,
                    repeatDelay : 0.3,
                    onComplete : () => {
                        litMutilplier.alpha = 0;
                        _this._allContainers[index].removeChild(litMutilplier);

                    }
                });
                if(_this._currentGameMode === "NORMAL") {
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.X5_MULTIPLIER);
                }
                _this._multiplierBlinkingAnim.play(0);
            }
        });
    }

    private showFreeSpinsMultIndicators() {

        const timeline:TimelineLite = new TimelineLite({
            onComplete : () => {
                this.blinkingEffect();
            }
        });
        this._usableMultipliers.forEach(function(item, index) {
            if((item as any).id == 5) {
                timeline.add(() => {
                    TweenLite.fromTo((item as any).indicator[0], 0.2, {alpha : 0}, {alpha : 1});
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.LIGHTS_ON);
                });

                timeline.add(() => {
                    TweenLite.fromTo((item as any).indicator[1], 0.2, {alpha : 0}, {alpha : 1});
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.LIGHTS_ON);
                }, 0.5);

                timeline.add(() => {
                    TweenLite.fromTo((item as any).indicator[2], 0.2, {alpha : 0}, {alpha : 1});
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.LIGHTS_ON);
                }, 1);

                timeline.play(0);
            }
        });

    }
}